var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 36,
    viewBox: "0 0 25 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3939 8.25C14.3939 7.42157 13.7156 6.75 12.8788 6.75C12.042 6.75 11.3636 7.42157 11.3636 8.25V11.25C11.3636 12.0784 12.042 12.75 12.8788 12.75C13.7156 12.75 14.3939 12.0784 14.3939 11.25V8.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C18.8608 1 24 6.10221 24 12.375V23.625C24 29.8978 18.8608 35 12.5 35C6.13923 35 1 29.8978 1 23.625V12.375C1 6.10221 6.13923 1 12.5 1ZM12.8788 7.75C13.1728 7.75 13.3939 7.98331 13.3939 8.25V11.25C13.3939 11.5167 13.1728 11.75 12.8788 11.75C12.5848 11.75 12.3636 11.5167 12.3636 11.25V8.25C12.3636 7.98331 12.5848 7.75 12.8788 7.75ZM15.3939 8.25C15.3939 6.85984 14.2584 5.75 12.8788 5.75C11.4992 5.75 10.3636 6.85984 10.3636 8.25V11.25C10.3636 12.6402 11.4992 13.75 12.8788 13.75C14.2584 13.75 15.3939 12.6402 15.3939 11.25V8.25Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseIcon);
export default __webpack_public_path__ + "static/media/mouse_icon.15b460d368bd1d2ff9c33e33247b692c.svg";
export { ForwardRef as ReactComponent };